import queryString from 'query-string';

import PortalTypes from 'Lib/constants/app/portalTypes';

import * as actions from './actions';
import { initialState } from './reducer';

import agent from '~/agent';
import * as storage from '~/services/app/storage';
import store from '~/store';

export const LOGIN_URL = 'session_applicant_LoginUrl';
const PATH_LENGTH = '/portals/applicant'.length;
const sessionTimeout = null;

const ROOT_DOMAIN = process.env.DOMAIN;
const CLIENT_ID = process.env.CLIENT_ID;

const getSubdomain = () => {
    // window.location.host is subdomain.domain.com
    var full = window.location.host;
    var parts = full.split('.');

    return parts[0];
};

const clearSession = () => {
    clearTimeout(sessionTimeout);
    // dispatch action to clear the session
    store.dispatch(actions.update(initialState));
};

const onAuthSuccess = response => {
    store.dispatch(actions.update({ isAuthenticated: true }));

    // Set a flag in local storage that the applicant has signed in. This way when
    // they are signed out we can take them to a sign in page instead of the
    // registration page
    storage.setPreviouslyAuthenticated();
};

const onAuthFailed = exception => {
    clearSession();
    throw exception;
};

const setLoginUrl = () => {
    // Omitting redirect as it's strictly used for the login action below to set the login URL in certain instances
    const { redirect, ...qs } = queryString.parse(window.location.search);
    const path = JSON.stringify({
        pathname: window.location.pathname.substring(PATH_LENGTH),
        search: queryString.stringify(qs)
    });

    window.localStorage?.setItem(LOGIN_URL, path);
};

export const getLoginUrl = () => {
    return window.localStorage?.getItem(LOGIN_URL);
};

export const clearLoginUrl = () => {
    window.localStorage.removeItem(LOGIN_URL);
};

export const impersonate = id => {
    const subdomain = getSubdomain();

    window.location.assign(`https://${subdomain}${ROOT_DOMAIN}/api/applicant/oauth/impersonate?id=${id}`);
};

export const login = () => {
    const qs = queryString.parse(window.location.search);

    // If redirect is present, then we need to set the login url
    if (qs.redirect) {
        setLoginUrl();
    }

    // OAuth Login
    const oauthQs = queryString.stringify({
        ...qs,
        client_id: CLIENT_ID,
        response_type: 'code',
        subdomain: getSubdomain(),
        portalType: PortalTypes.Applicant,
        previouslyAuthenticated: storage.getPreviouslyAuthenticated()
    });

    window.location.assign(`https://account${ROOT_DOMAIN}/oauth2/authorize?${oauthQs}`);
};

export const checkForSession = () => {
    store.dispatch(actions.update({ isAuthenticated: true }));
};

export const requestToken = code => {
    return agent.requestToken({ code }).then(onAuthSuccess).catch(onAuthFailed);
};

export const refreshToken = () => {
    // return agent.refreshToken().then(onAuthSuccess).catch(onAuthFailed);
};

export const logout = () => {
    setLoginUrl();

    // OAuth Login
    const oauthQs = queryString.stringify({
        portalID: PortalTypes.Applicant,
        subdomain: getSubdomain()
    });

    return agent
        .revokeToken()
        .then(() => {
            clearSession();
        })
        .finally(() => {
            window.location.assign(`https://account${ROOT_DOMAIN}/oauth2/logout?${oauthQs}`);
        });
};
